import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

export const header = (theme: Theme) => css`
  background-color: ${theme.ds5.surface.level1};
  padding: ${theme.ds5.spacing.padding.small} 0;
`;

export const wrapper = (theme: Theme) => css`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.medium};
`;

export const backWrapper = css`
  display: flex;
  align-items: center;
  justify-self: start;
`;

export const backButton = (theme: Theme) => css`
  display: inline-flex;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.xsmall};
  color: ${theme.ds5.neutral.text};
  text-decoration: underline;
`;

export const backButtonMobile = (theme: Theme) => css`
  display: inline-flex;
  align-items: center;
  color: ${theme.ds5.neutral.text};
`;

export const stepperWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: center;
`;

export const mobileStepperWrapper = (theme: Theme) => css`
  padding: ${theme.ds5.spacing.padding.xsmall} ${theme.ds5.spacing.padding.small};
`;

export const stepperNav = css`
  width: 450px;

  @media (max-width: ${dimensions.tabletMax}) {
    max-width: 100%;
    width: auto;
  }
`;

export const secureBadge = css`
  display: flex;
  align-items: center;
  justify-self: end;
`;

export const secureIcon = (theme: Theme) => css`
  margin-right: ${theme.ds5.spacing.gap.small};
`;
